import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { BannerType } from '../../../types';
import { useTheme, CacheProvider } from '../../../providers';
const CSS = {
    banner: () => css({
        '& iframe, img': {
            maxWidth: '100%',
            height: 'auto',
        },
    }),
};
export function Banner(properties) {
    const globalTheme = useTheme();
    const props = {
        // default props
        content: [],
        type: '',
        // global theme
        ...globalTheme?.components?.banner,
        // props
        ...properties,
        ...properties.theme?.components?.banner,
    };
    const { content, type, disableStyles, className, style } = props;
    if (type === BannerType.INLINE) {
        console.warn(`BannerType '${BannerType.INLINE}' is not supported in <Banner /> component`);
        return;
    }
    const styling = {};
    if (!disableStyles) {
        styling.css = [CSS.banner(), style];
    }
    else if (style) {
        styling.css = [style];
    }
    return (content &&
        content[type]?.length && (jsx(CacheProvider, null,
        jsx("div", { className: classnames('ss__banner', `ss__banner--${type}`, className), ...styling, dangerouslySetInnerHTML: {
                __html: content[props.type].join(''),
            } }))));
}
